module.exports = __webpack_public_path__ + "static/media/logo395x89-1.60550be2.png";